const KEYS = {
  CLICK_ID: 'sn_click_id',
} as const;

const COOKIE_TTL_DAYS = {
  CLICK_ID: 30,
} as const;

class StorageService {
  private cookieDomain(): string {
    const { hostname } = window.location;
    return hostname.includes('shortsninja.com') ? '.shortsninja.com' : hostname;
  }

  private readCookie(name: string): string | undefined {
    try {
      const match = document.cookie.match(
        new RegExp(`(?:^|; )${name}=([^;]*)`)
      );
      return match ? decodeURIComponent(match[1]) : undefined;
    } catch {
      return undefined;
    }
  }

  private writeCookie(name: string, value: string, days: number): void {
    try {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${encodeURIComponent(
        value
      )}; expires=${expires}; path=/; domain=${this.cookieDomain()}; SameSite=Lax`;
    } catch {
      return;
    }
  }

  private deleteCookie(name: string): void {
    try {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${this.cookieDomain()}`;
    } catch {
      return;
    }
  }

  private readLocalStorage(key: string): string | undefined {
    try {
      return localStorage.getItem(key) ?? undefined;
    } catch {
      return undefined;
    }
  }

  private writeLocalStorage(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      return;
    }
  }

  private deleteLocalStorage(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      return;
    }
  }

  private readFromUrlParam(param: string): string | undefined {
    try {
      return (
        new URLSearchParams(window.location.search).get(param) ?? undefined
      );
    } catch {
      return undefined;
    }
  }

  getClickId(): string | undefined {
    const fromUrl = this.readFromUrlParam('clickId');
    if (fromUrl) {
      this.writeLocalStorage(KEYS.CLICK_ID, fromUrl);
      return fromUrl;
    }

    return (
      this.readLocalStorage(KEYS.CLICK_ID) ?? this.readCookie(KEYS.CLICK_ID)
    );
  }
}

export const storageService = new StorageService();
